import React from 'react';
import { css } from '@emotion/css';
import ReactTable, { Column, ComponentPropsGetterR, ComponentPropsGetter0 } from 'react-table';
import { color_shades_dark, ocean_blue } from '../../constants/colors';
import Button from '../general/Button';
import SortAndPageControl from '../general/SortAndPageControl';
import NumberIncrementSelector from '../forms/NumberIncrementSelector';
import RoundedSelectField from '../forms/RoundedSelectField';
const csvIcon = require("../../content/images/analytics-icons/csv.svg");
// component wrapping the react-table component to allow for consistent styles and functionality

interface SortedTableProps {
    columns?: Column[]
    data?: any[]
    className?: string
    showPagination?: boolean
    pageSize?: number
    getTrProps?: ComponentPropsGetterR | ComponentPropsGetter0;
    getExportableData: () => string[][]
    exportName: string
}

interface SortedTableState {
    pageSize: number
    pageNumber: number
    isGroupedByTimePeriod?: boolean
}

class ReportTable extends React.Component<SortedTableProps, SortedTableState>{
    pageSizes = [5, 10, 20, 50, 100];
    constructor(props) {
        super(props);
        this.state = {
            pageNumber: 1,
            pageSize: props.pageSize ? props.pageSize : (localStorage.getItem("defaultPageSize") ? parseInt(localStorage.getItem("defaultPageSize")) : 20)
        }
    }
    handleDownload() {
        const rows = this.props.getExportableData();
        let csvContent = "data:text/csv;charset=utf-8,"
            + rows.map(e => e.join(",")).join("\n");
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `${this.props.exportName}.csv`);
        document.body.appendChild(link); // Required for FF
        link.click();
        link.remove();
    }
    handlePage(increment: boolean) {
        const currentDataSize = this.props.data?.slice((this.state.pageNumber - 1) * this.state.pageSize, this.state.pageNumber * this.state.pageSize)?.length ?? 0;
        var pageNumber = this.state.pageNumber;
        if (increment && currentDataSize >= this.state.pageSize) {
            pageNumber++;
        } else if (!increment && this.state.pageNumber > 1) {
            pageNumber--;
        }
        this.setState({
            ...this.state,
            pageNumber
        })
    }
    handlePageSizeChange(size: any) {
        this.setState({
            ...this.state,
            pageSize: size.value,
            pageNumber: 1
        });
    }
    render() {
        const props = this.props;
        return (
            <div className={containerStyle}>
                <div className="table-options-header">
                    <div className="table-pagination-options">
                        <div className="page-size-option">
                            <p>Rows per Page</p>
                            <RoundedSelectField
                                options={this.pageSizes.map(v => ({ label: v.toString(), value: v }))}
                                onChange={this.handlePageSizeChange.bind(this)}
                                value={this.state.pageSize.toString()} />
                        </div>
                        <NumberIncrementSelector
                            selectedNumber={this.state.pageNumber.toString()}
                            updateValue={this.handlePage.bind(this)}
                            showNumber={true} />
                        <Button themes={['secondary-small', 'end-tight']} className="ac-analytics-report-download-button" text="Download" rightIcon={csvIcon} onClick={this.handleDownload.bind(this)} />
                    </div>
                </div>
                <ReactTable className={`${tableStyles} ${props.className}`}
                    data={props.data.slice((this.state.pageNumber - 1) * this.state.pageSize, this.state.pageNumber * this.state.pageSize)}
                    columns={props.columns}
                    showPagination={false}
                    onPageSizeChange={this.handlePageSizeChange.bind(this)}
                    showPaginationBottom={false}
                    pageSize={this.state.pageSize}
                    getTrProps={props.getTrProps}
                    minRows={1} />

            </div>
        );
    }
}

const containerStyle = css`
    border-top:1px solid ${color_shades_dark};
    background: white;
    margin-bottom: 128px;
    .table-options-header {
        height: 56px;
        margin: 0 32px;
        display: flex;
        align-items: center;
        border-bottom:1px solid ${color_shades_dark};

        .table-pagination-options {
            margin-right: 0;
            margin-left: auto;
            display: flex;
            align-items: center;
            > * {
                margin-left: 16px;
            }
            .page-size-option {
                display: flex;
                align-items: center;
                >p {                                
                    font-size: 14px;
                    line-height: 20px;
                    margin-right: 8px;
                }
                >.selector {
                    .Select-control {
                        width: 80px;
                    }
                    .Select-value {
                        margin-left: 8px;
                    }
                }
            }

        }
    }
`

const tableStyles = css`
    border: none;
    overflow: hidden;
    .rt-table {
        background: white;
        overflow: hidden;
        .rt-thead, .rt-thead -header {
            padding: 0 32px;
            box-shadow: none;
            border-bottom: solid 1px ${color_shades_dark};
            .rt-th {
                border: none;
                box-shadow: none;
                div {
                    height: 100%;
                }
            }
        }
        .rt-tbody {
            min-height: 64px;
            .rt-tr-group {
                min-height: 52px;
                border-bottom: solid 1px #cccccc;

                .rt-tr {
                    background: transparent;
                    padding: 0 32px;
                    border: none;
                    overflow: visible;
                }
            }
        }

        div.rt-td {
            background: transparent;
            align-self: center;
            overflow: visible;
        }
    }
`;
export default ReportTable;